import styled, {css} from "styled-components";

import tutorialBg from './../../assets/images/static/tutorialBg.png';

import { HeadingTitle, StyledHeroSection } from "./../Tutorials/styled";

export const StyledFaqSection = styled.section``;

export const FaqsHeroSection = styled(StyledHeroSection)`
  background: url(${tutorialBg}) no-repeat bottom center;
  background-size: cover;
  min-height: 750px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    min-height: 590px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    min-height: 540px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    min-height: 500px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    min-height: 430px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    min-height: 360px;
  }
  h4 {
    width: 500px;
  }
`;

export const FaqsTitle = styled(HeadingTitle)`
  width: 500px;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 400px;
  }
`;

export const FaqsWrapper = styled.div`
  margin: 50px auto;
  width: 1140px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin: 32px auto;
    width: 1000px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin: 28px auto;
    width: 850px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    margin: 24px auto;
    width: 740px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    width: 620px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    width: 90%;
  }
`;

export const StyledFaqDetails = styled.details`
  border-bottom: 1px solid ${({theme}) => theme.colors.lighter};
  position: relative;
  svg {
    color: ${({theme}) => theme.colors.default};
    font-size: ${({theme}) => theme.fonts.subTitle};
    position: absolute;
    right: 12px;
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.hdSubTitle};
      right: 10px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.secondarySize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
      right: 8px;
    }
  }
  ${props => props.open && css`
    border: 1px solid white;
  `}
`;

export const StyledFaqSummary = styled.summary`
  color: ${({theme}) => theme.colors.alternate};
  font-family: 'RubikBold';
  padding: 40px 0;
  appearance: auto;
  -moz-appearance: auto;
  -webkit-appearance: auto;
  &:hover {
    background-color: ${({theme}) => theme.colors.light};
    cursor: pointer;
  }
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 32px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 28px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 24px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    padding: 20px 0;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    padding: 24px 0;
  }
`;

export const StyledFaqParagraph = styled.p`
  border-top: 1px solid ${({theme}) => theme.colors.lighter};
  color: ${({theme}) => theme.colors.default};
  padding: 20px;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 16px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 12px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    text-align: justify;
    padding: 8px;
  }
  span {
    font-family: 'RubikRegular';
  }
`;
